import { createApiRef } from '@backstage/core-plugin-api';

export const drEventTaxonomyReferenceDataProxyApiRef = createApiRef<DrEventTaxonomyReferenceDataProxyApi>({
  id: 'plugin.dr-event-taxonomy-reference-data-api.service',
});

export type ApiResponse<T> = {
  data: T;
};

export type PromMetrics = {
  status: string;
  data: PromData;
};

export type PromData = {
  resultType: 'vector';
  result: {
    metric?: any;
    value: any[];
  }[];
};

export interface DrEventTaxonomyReferenceDataProxyApi {
  get<T>(path: string): Promise<T | Response>;
}

export type FailureSample = {
  timestamp: string;
  request: any;
  response: any;
  topic: string;
};

export type EventsDetailedMap = {
  failureSampling: FailureSample[];
} & {
  [eventName: string]: MoveAvroSchema;
};

export type EventsMap = {
  [eventName: string]: {
    type: string;
    name: string;
    namespace: string;
    doc: string;
    fields: any[];
    prism_metadata: {
      ingestion_type: string;
      source_info: {
        owner_email: string[];
        owner_slack_channel: string[];
      };
    };
    data_reliability_metadata: {
      owning_org: string[];
      event_description: string[];
    };
  };
};

export type BaseAvroSchema = {
  name?: string;
  type?: string | [string, MoveAvroSchema] | string[] | MoveAvroSchema | any;
  doc?: string;
  default?: any;
  symbol?: any;
  'tracking-validation'?: TrackingValidation;
  data_reliability_metadata?: {
    owning_org?: string[];
  };

  [x: string | number | symbol]: unknown;
};

export interface MoveAvroSchema extends BaseAvroSchema {
  fields?: BaseAvroSchema[];
  namespace?: string;

  [x: string | number | symbol]: unknown;
}

export enum RuleLeftHandSide {
  index = 'index',
  value = 'value',
  length = 'length',
}

export enum RuleOperator {
  equal = 'equal',
  less_than = 'less_than',
  greater_than = 'greater_than',
  less_than_or_equal = 'less_than_or_equal',
  greater_than_or_equal = 'greater_than_or_equal',
  in = 'in',
  match = 'match',
}

export type ValidationRule = {
  leftHandSide?: RuleLeftHandSide;
  index?: number;
  operator?: RuleOperator;
  negate?: boolean;
  rightHandSide?: string | number | boolean | string[] | number[] | null;
  validationErrorMessage?: string | undefined;
};

export type TrackingValidation = {
  NOTE?: string;
  isOptional?: boolean;
  delimiter?: string;
  examples?: [];
  rules?: ValidationRule[];
};

export type PDASchema = {
  datasetName: string;
  schemaId: number;
  schemaVersion: number;
  schema: MoveAvroSchema;
};
